import * as React from 'react';
import accounting from 'accounting';
import * as moment from 'moment';
import { goToPartDetail, partDetailUrl } from 'src/utils/navigation';
import OrderLineModel, { ITrackingInfo } from 'src/model/orderline.model';
import { IOrders } from 'src/model/modules/orders.model';

import './OrderRow.scss';
import PartReturnModel from 'src/model/partReturn.model';
import env from 'src/shared/env';

interface IOrderRowProps {
  order: IOrders;
  partId: string;
  part: any;
  status: string;
  invoiceId: string;
  trackingNumbers: ITrackingInfo[];
  t?: any;

  handleModalClicked: (
    invoices: { [key: string]: OrderLineModel[] },
    status: string,
    poNumber: string,
    date: string,
    part: PartReturnModel
  ) => void;
}

interface IOrderRowState {
  isChecked: boolean;
}

function dateStringToNumber(date: string): number {
  return parseInt(date.split('-').join(''), 10);
}

class OrderRow extends React.Component<IOrderRowProps, IOrderRowState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isChecked: false
    };
  }

  private getTrackingNumber = (lineNumber: number) => {
    const order = this.props.order;

    return this.props.trackingNumbers.find(
      tn =>
        tn.lineNumber === lineNumber &&
        tn.orderNumber === order.orderNumber &&
        tn.orderDate === dateStringToNumber(order.orderDate)
    );
  };

  private renderTrackingInfo = (lineNumber: number) => {
    const tn = this.getTrackingNumber(lineNumber);
    return tn && tn.trackingNumber && tn.trackingNumber.length ? (
      <a className="rp-track--tracking" href={tn.trackingLink} target="_blank">
        {tn.trackingNumber}
      </a>
    ) : (
      <span className="rp-track--no-tracking">N/A</span>
    );
  };

  private renderShipmentInfo = (lineNumber: number) => {
    const tn = this.getTrackingNumber(lineNumber);
    return tn && tn.motName && tn.motName.length ? tn.motName : 'N/A';
  };

  private mapCancellationItemstatus = (status: number) => {
    const { t } = this.props;
    switch (status) {
      case 0:
        return {
          label: `${t('myOrders.cancelItem')}`,
          subClass: 'cancellable'
        };
      case 1:
        return {
          label: `${t('myOrders.cancelRequested')}`,
          subClass: 'cancel-requested'
        };
      case 3:
        return { label: `${t('myOrders.cancelled')}`, subClass: 'cancelled' };
      case 4:
        return {
          label: 'Cancellation unsuccesful',
          subClass: 'cancellation-unsuccesful'
        };
      default:
        return { label: '', subClass: '' };
    }
  };

  private renderCancellationInfo = () => {
    const { status, order, part } = this.props;
    return (
      <span
        className={`rp-track--cancellation ${
          this.mapCancellationItemstatus(part.cancellationStatus).subClass
        }`}
        onClick={() => {
          if (part.cancellationStatus === 0) {
            this.props.handleModalClicked(
              {},
              status,
              order.poNumber,
              moment(order.orderDate).format('MM/DD/YY'),
              {
                partId: this.props.partId,
                ...this.props.part
              }
            );
          } else {
            return;
          }
        }}
      >
        {this.mapCancellationItemstatus(part.cancellationStatus).label}
      </span>
    );
  };

  public render() {
    const { part, status, t } = this.props;
    const HAS_INVOICED = 'Invoiced';
    return (
      <tr className="rp-orders-table-item--table-row">
        <td>
          <table className="rp-orders-table-item--table-row-info">
            <tr>
              <td className="rp-orders-table-item--special-order">
                {part.specialOrder && (
                  <i
                    title="Special Order"
                    className="rpds rpds-new-releases special-order"
                  />
                )}
              </td>
              <td className="rp-orders-table-item--table-column link rp-part-number-area">
                <a
                  href={partDetailUrl(
                    `${part.manufacturerCode}  ${part.productNumber}`
                  )}
                  className="link"
                  onClick={e =>
                    goToPartDetail(
                      `${part.manufacturerCode}  ${part.productNumber}`
                    )
                  }
                >
                  {`${part.manufacturerCode} ${part.productNumber}`}
                </a>
              </td>
              <td className="rp-orders-table-item--table-column rp-description-area">
                {part.description ? part.description : 'N/A'}
              </td>
              <td className="rp-orders-table-item--table-column rp-qty-area">
                {part.quantity ? part.quantity : 0}
              </td>
              <td className="rp-orders-table-item--table-column rp-price-area">
                {part.price ? accounting.formatMoney(part.price) : 'N/A'}
              </td>
              <td className="rp-orders-table-item--table-column rp-amount-area">
                {part.amount ? accounting.formatMoney(part.amount) : 'N/A'}
              </td>
              <td className="rp-orders-table-item--table-column rp-ship-from-area">
                {part.shippedFromLocation ? part.shippedFromLocation : 'N/A'}
              </td>
              <td className="rp-orders-table-item--table-column rp-shipment-marking-area">
                {part.shipmentMarking ? part.shipmentMarking : 'N/A'}
              </td>
              {env.REACT_APP_BASE_ENVIRONMENT === 'US' ? (
                <td className="rp-orders-table-item--table-column rp-delivery-date">
                  {part.deliveryDate
                    ? moment(part.deliveryDate).format('MM/DD/YY')
                    : 'N/A'}
                </td>
              ) : (
                <td className="rp-orders-table-item--table-column rp-shipment-info">
                  {status === 'Backordered' && !part.invoiceNumber
                    ? 'N/A'
                    : this.renderShipmentInfo(part.lineNumber)}
                </td>
              )}
              <td
                className={`rp-orders-table-item--table-column ${
                  (status === 'Backordered' ||
                    status === 'Order Cancelled' ||
                    status === 'Order Received') &&
                  !part.invoiceNumber
                    ? ''
                    : 'link'
                } rp-track-no-area`}
              >
                {(status === 'Backordered' ||
                  status === 'Order Cancelled' ||
                  status === 'Order Received') &&
                !part.invoiceNumber ? (
                  this.renderCancellationInfo()
                ) : part.trackingNumber ? (
                  <a href={part.trackingLink} target="_blank">
                    {part.trackingNumber}
                  </a>
                ) : (
                  'N/A'
                )}
              </td>
              <td className="rp-orders-table-item--table-column rp-shipment-orderdetails-status">
                {part.orderDetailStatus ? part.orderDetailStatus : 'N/A'}
              </td>
            </tr>
          </table>
          {/* Mobile view */}
          <div className="rp-orders-table-item--table-mobile">
            <div className="rp-orders-table-item--table-column mobile-part">
              {part.specialOrder && (
                <i
                  title="Special Order"
                  className="rpds rpds-new-releases special-order"
                />
              )}
              <div className="rp-order-row-cancel-item rp-mobile-area-all ">
                <a
                  href={partDetailUrl(
                    `${part.manufacturerCode}  ${part.productNumber}`
                  )}
                  className="link"
                  onClick={e =>
                    goToPartDetail(
                      `${part.manufacturerCode}  ${part.productNumber}`
                    )
                  }
                >
                  {`${part.manufacturerCode} ${part.productNumber}`}
                </a>
                {this.renderCancellationInfo()}
              </div>
            </div>
            <div className="rp-orders-table-item--table-column">
              {part.description ? part.description : 'N/A'}
            </div>
            <div className="rp-orders-table-item--table-column">
              <label>{t('myOrders.qty')}</label>
              {part.quantity ? part.quantity : 0}
            </div>
            <div className="rp-mobile-area-all">
              <div className="rp-orders-table-item--table-column rp-price-area">
                <label>{t('myOrders.price')}</label>
                {part.price ? accounting.formatMoney(part.price) : 'N/A'}
              </div>
              <div className="rp-orders-table-item--table-column rp-amount-area">
                <label>{t('common.amount')}</label>
                {part.amount ? accounting.formatMoney(part.amount) : 'N/A'}
              </div>
            </div>
            <div className="rp-orders-table-item--table-column rp-mobile-area-all">
              <label>{t('tracking.headers.shippedFrom')}</label>
              {part.shippedFromLocation ? part.shippedFromLocation : 'N/A'}
            </div>
            <div className="rp-orders-table-item--table-column rp-mobile-area-all">
              <label>{t('myOrders.searchByKeys.shipmentMarking')}</label>
              {part.shipmentMarking ? part.shipmentMarking : 'N/A'}
            </div>
            {env.REACT_APP_BASE_ENVIRONMENT === 'US' ? (
              <div className="rp-orders-table-item--table-column rp-mobile-area-all">
                <label>{t('myOrders.deliveryDate')}</label>
                {part.deliveryDate
                  ? moment(part.deliveryDate).format('MM/DD/YY')
                  : 'N/A'}
              </div>
            ) : (
              <div className="rp-orders-table-item--table-column rp-mobile-area-all">
                <label>
                  {(t('myOrders.shipmentInfo') as string).toLowerCase()}
                </label>
                {(status === 'Backordered' ||
                  status === 'Order Cancelled' ||
                  status === 'Order Received') &&
                !part.invoiceNumber
                  ? this.renderCancellationInfo()
                  : this.renderShipmentInfo(part.lineNumber)}
              </div>
            )}
            <div className="rp-orders-table-item--table-column rp-mobile-area-all">
              {/* <label>{(t('myOrders.trackNo') as string).toLowerCase()} </label> */}

              {/* <span className="link">
              {status === 'Backordered' && !part.invoiceNumber
                ? null
                : this.renderTrackingInfo(part.lineNumber)}
            </span> */}
              <span className="link">
                {status === 'Backordered' &&
                !part.invoiceNumber ? null : part.trackingNumber ? (
                  <a href={part.trackingLink} target="_blank">
                    {part.trackingNumber}
                  </a>
                ) : (
                  'N/A'
                )}
              </span>
            </div>
            <div className="rp-orders-table-item--table-column rp-mobile-area-all">
              <label>{(t('myOrders.status') as string).toLowerCase()} </label>

              {part.orderDetailStatus ? part.orderDetailStatus : 'N/A'}
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

export default OrderRow;
